import { Descope } from '@descope/react-sdk';
import React from 'react';

export function ChangePassword() {
  return (
    <Descope
      flowId="change-password"
      onSuccess={async () => {
        window.open('/auth/sign-in');
      }}
    />
  );
}
